var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box wrapper-payroll-deductions" },
    [
      _c("div", { staticClass: "title-container is-flex" }, [
        _c(
          "h4",
          {
            staticClass:
              "title is-centered is-4 has-text-primary title-payroll-deductions"
          },
          [_vm._v("\n      Deducciones\n    ")]
        ),
        _c(
          "div",
          { staticClass: "field is-centered" },
          [
            _c(
              "BTooltip",
              {
                staticClass: "add-button",
                attrs: { label: "Agregar deducción", type: "is-success" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "button add-deduction is-success is-rounded",
                    on: {
                      click: function($event) {
                        return _vm.$store.commit("payroll/addDeductionRow")
                      }
                    }
                  },
                  [_c("BIcon", { attrs: { icon: "plus" } })],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _c(
        "BTable",
        {
          attrs: { data: _vm.deductionsWithIndex, columns: _vm.columns },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(props) {
                return [
                  _c(
                    "BTableColumn",
                    {
                      staticClass: "limit-300",
                      attrs: { field: "deductionType", internal: "" }
                    },
                    [
                      _c(
                        "BField",
                        [
                          _c(
                            "BSelect",
                            {
                              staticClass: "is-fullwidth",
                              attrs: {
                                name: "deductionType",
                                placeholder: "Selecciona el tipo",
                                value: props.row.deductionType,
                                disabled: _vm.loading,
                                loading: _vm.loading,
                                required: ""
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onInput(
                                    props.row.id,
                                    "deductionType",
                                    $event
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.deductionTypeCatalog, function(option) {
                              return _c(
                                "option",
                                {
                                  key: option.value,
                                  domProps: { value: option.value }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(option.label) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "key", internal: "" } },
                    [
                      _c(
                        "BField",
                        [
                          _c("BInput", {
                            attrs: {
                              name: "key",
                              placeholder: "Ingresa una clave de deducción",
                              value: props.row.key,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.onInput(props.row.id, "key", $event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "concept", internal: "" } },
                    [
                      _c(
                        "BField",
                        [
                          _c("BInput", {
                            attrs: {
                              name: "concept",
                              placeholder:
                                "Ingresa el concepto de la deducción",
                              value: props.row.concept,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.onInput(
                                  props.row.id,
                                  "concept",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "amount", internal: "" } },
                    [
                      _c(
                        "BField",
                        [
                          _c("BInput", {
                            attrs: {
                              name: "amount",
                              placeholder: "Ingresa el monto a deducir",
                              type: "number",
                              min: "0",
                              step: "0.01",
                              value: props.row.amount,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.onInput(
                                  props.row.id,
                                  "amount",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "actions", internal: "" } },
                    [
                      _c("span", { staticClass: "actions" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button is-danger",
                            on: {
                              click: function($event) {
                                return _vm.$store.commit(
                                  "payroll/deleteDeduction",
                                  props.row.id
                                )
                              }
                            }
                          },
                          [
                            _c("BIcon", {
                              attrs: { icon: "delete", "aria-hidden": "true" }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "empty" }, [
            _c("section", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c(
                    "p",
                    [
                      _c("BIcon", {
                        attrs: { icon: "emoticon-sad", size: "is-large" }
                      })
                    ],
                    1
                  ),
                  _c("p", [_vm._v("No has agregado deducciones")])
                ]
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }